module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-121.b1da0ae3.svg";